/**
 * Live Score Bar - Sticky behavior
 * Makes the live score bar stick to the top when scrolling
 * Syncs with navbar hide/show behavior
 */
(function() {
    'use strict';

    function initLiveScoreSticky() {
        const wrapper = document.querySelector('.live-score-bar-wrapper');
        if (!wrapper) return;

        const bar = wrapper.querySelector('.live-score-bar');
        if (!bar) return;

        const navbar = document.getElementById('st-navbar');

        // Height of the fixed header (desktop: 62px, mobile: 60px)
        const headerHeightDesktop = 62;
        const headerHeightMobile = 60;
        const headerHiddenOffset = 0; // When header is hidden, stick to top

        function getHeaderHeight() {
            return window.innerWidth >= 992 ? headerHeightDesktop : headerHeightMobile;
        }

        function updateStickyPosition() {
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            const headerHeight = getHeaderHeight();

            // Recalculate offset on each scroll to handle dynamic content
            const stickyOffset = wrapper.offsetTop;

            // On mobile and desktop, only stick when the bar reaches the header position
            const isSticky = scrollPosition >= stickyOffset - headerHeight;

            if (isSticky) {
                bar.classList.add('is-sticky');

                // Adjust top position based on navbar visibility
                if (navbar && navbar.classList.contains('st-navbar-hidden')) {
                    bar.style.top = headerHiddenOffset + 'px';
                } else {
                    bar.style.top = headerHeight + 'px';
                }
            } else {
                bar.classList.remove('is-sticky');
                bar.style.top = ''; // Reset inline style
            }
        }

        // Listen to scroll events
        window.addEventListener('scroll', updateStickyPosition);

        // Listen to resize events to recalculate on orientation change
        window.addEventListener('resize', updateStickyPosition);

        // Initial check
        updateStickyPosition();
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLiveScoreSticky);
    } else {
        initLiveScoreSticky();
    }
})();
